<div class="flex flex-col px-4 gap-6 lg:px-0 lg:max-w-6xl lg:mx-auto pt-6 lg:py-12 w-full">
  @if (data(); as news) {
  <!-- 목록으로 버튼 -->
  <button routerLink=".." class="cursor-pointer flex items-center gap-1 hover:text-zinc-600 transition-colors w-fit">
    <app-icon name="mdi:chevron-left" class="size-5! text-zinc-300" />
    <span class="text-zinc-400 font-medium">목록으로</span>
  </button>

  <div class="flex flex-col gap-3">
    <h1 class="sb-aggro text-lg lg:text-3xl font-light text-zinc-800">[보도자료] {{ news.title }}</h1>
    <div class="text-sm text-zinc-400 font-medium">
      {{ news.displayDate || news.createdAt | date : 'yyyy-MM-dd HH:mm' }}
    </div>
  </div>

  <div class="w-full h-px bg-zinc-100"></div>

  <!-- 본문 영역 -->
  @if (news.content) {
  <div
    class="editor-content prose prose-zinc max-w-none prose-headings:font-normal prose-p:text-zinc-700 prose-p:leading-relaxed prose-li:text-zinc-700"
    [innerHTML]="news.content | safeHtml"></div>
  }

  <!-- 링크 영역 -->
  @if (news.link) {
  <div class="flex items-center gap-2 p-4 bg-zinc-50 rounded-lg">
    <app-icon name="mdi:link-variant" class="size-5! text-zinc-400 shrink-0" />
    <a [href]="news.link" target="_blank" rel="noopener noreferrer"
      class="text-primary-500 hover:underline text-sm font-medium truncate">
      {{ news.link }}
    </a>
    <app-icon name="mdi:open-in-new" class="size-4! text-zinc-400 shrink-0 ml-auto" />
  </div>
  }

  <!-- 이전글/다음글 영역 -->
  <div class="flex flex-col border-y border-zinc-100">
    <!-- 이전글 -->
    @if (prevNews(); as prev) {
    <div
      [routerLink]="['..', prev.id]"
      class="flex items-center gap-3 p-6 border-b border-zinc-100 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ prev.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ prev.displayDate || prev.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6 border-b border-zinc-100">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 이전글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 이전 글이 없습니다. </span>
    </div>
    }

    <!-- 다음글 -->
    @if (nextNews(); as next) {
    <div
      [routerLink]="['..', next.id]"
      class="flex gap-3 items-center p-6 hover:bg-zinc-50 transition-colors cursor-pointer">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-800 font-medium flex-1 truncate">
        {{ next.title }}
      </span>
      <span class="text-sm text-zinc-400 shrink-0 font-medium">
        {{ next.displayDate || next.createdAt | date : 'yyyy.MM.dd' }}
      </span>
    </div>
    } @else {
    <div class="flex items-center gap-3 p-6">
      <span class="text-sm text-zinc-400 font-medium shrink-0"> 다음글 </span>
      <span class="text-sm text-zinc-400 flex-1"> 다음 글이 없습니다. </span>
    </div>
    }
  </div>

  <!-- 하단 목록으로 버튼 -->
  <div class="flex justify-center">
    <button
      routerLink=".."
      class="cursor-pointer w-full lg:w-[30%] py-2 border border-zinc-200 text-zinc-800 rounded-lg font-medium">
      목록으로
    </button>
  </div>
  }
</div>
